/**
 * How we came by an answer we entered for a customer. Mirrors ENTRY_METHODS in
 * functions/src/intake/staffEntry.ts; entryMethods.guard.test.ts holds them together.
 */
export const ENTRY_METHODS = [
  { key: 'phone', label: 'Phone call', phrase: 'a phone call' },
  { key: 'email', label: 'Email', phrase: 'an email' },
  { key: 'videoCall', label: 'Video call', phrase: 'a video call' },
  { key: 'inPerson', label: 'In person', phrase: 'a meeting in person' },
  { key: 'other', label: 'Other', phrase: 'another source' },
] as const;

export type EntryMethod = (typeof ENTRY_METHODS)[number]['key'];

export function methodPhrase(method: string, detail?: string | null): string {
  if (method === 'other' && detail?.trim()) return detail.trim();
  return ENTRY_METHODS.find((m) => m.key === method)?.phrase ?? 'another source';
}
